<template>
    <div>
        <h1>Adding...</h1>
    </div>
</template>

<script>
import guests from "../services/guests";

export default {
    name: "removeGuestFromSchedule",
    props: [
    	"event_id",
    	"schedule_id",
    	"external_id"
    ],
    created() {
        console.debug("removeGuestFromSchedule", "created");
        guests.removeCheckin(this.$props.event_id, this.$props.schedule_id, this.$props.external_id);
    }
};
</script>